/**
 * Generates unique and stable IDs to link form field elements
 * (input, label, helper text) via ARIA attributes.
 */
import { useRef } from 'react';

type FieldIds = {
  baseId: string;
  labelId: string;
  helperId: string;
  validationId: string;
};

let counter = 0;

function useFieldId(prefix = 'field'): FieldIds {
  const idsRef = useRef<FieldIds | null>(null);
  if (idsRef.current === null) {
    counter += 1;
    const base = `${prefix}-${counter}`;
    idsRef.current = {
      baseId: base,
      labelId: `${base}-label`,
      helperId: `${base}-helper`,
      validationId: `${base}-validation`,
    };
  }
  return idsRef.current;
}

export default useFieldId;
